// frontend/src/pages/TrialExpiredPage.jsx
import React from 'react';
import { Box, Button, H1, Panel, Text } from '@bigcommerce/big-design';
import { useNavigate } from 'react-router-dom';

const TrialExpiredPage = () => {
  const navigate = useNavigate();

  return (
    <Box margin="xxLarge" padding="large">
      <H1 style={{ marginTop: '30px' }}>Your free trial has ended</H1>

      <Panel>
        <Text marginBottom="medium">
          Subscribe to keep managing fees and delivering them to checkout. Your existing fees and
          settings are safe; they'll pick back up as soon as you subscribe.
        </Text>
        <Button variant="primary" onClick={() => navigate('/settings#subscription-panel')}>
          Go to Settings to Subscribe
        </Button>
      </Panel>
    </Box>
  );
};

export default TrialExpiredPage;
